import moment from 'moment';
import { locale } from './locale';

moment.locale(locale);
